import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Dialog from '@material-ui/core/Dialog'
import { Title, ButtonContainer } from '../../healtheraComponents'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import InputBase from '@material-ui/core/InputBase'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@material-ui/core/InputAdornment'

class LegacyBranchesDialog extends Component {

  state = { branchesList: null }
  handleClose = () => {
    this.props.onClose()
  }

  handleListItemClick = (value) => {
    this.props.onClose(value)
    this.setState({ branchesList: null })
  }

  searchList(event) {
    let searchList = this.props.branches
    searchList = searchList.filter((branch) => branch.pharmacy_name.toLowerCase().search(event.target.value.toLowerCase()) !== -1)
    this.setState({ branchesList: searchList })
  }

  render() {
    const { geozoneSearch } = this.props
    const { open } = this.props
    const { branchesList } = this.state
    const branches = branchesList || this.props.branches
    return (
      <Fragment>
        <StyledDialog onClose={this.handleClose.bind(this)} open={open} aria-labelledby='legacy-branches' scroll={'paper'}>
          <Title margin={`20px 0 20px 0`} textAlign={'center'}>Please select a pharmacy branch to link</Title>
          <SearchBar inputProps={{ 'aria-label': 'Search' }}
            onChange={this.searchList.bind(this)}
            startAdornment={<InputAdornment position='start'><SearchIcon /></InputAdornment>} />
          <DialogContent>
            {geozoneSearch && branches && <List>
              {branches.filter(branch => branch.geozoneID === undefined).map(branch => (
                < Branch button onClick={this.handleListItemClick.bind(this, branch)} key={branch.pharmacy_id} >
                  <ListItemText primary={branch.pharmacy_name} />
                </Branch>
              ))}
            </List>}
            {!geozoneSearch && branches && <List>
              {branches.map(branch => (
                < Branch button onClick={this.handleListItemClick.bind(this, branch)} key={branch.pharmacy_id} >
                  <ListItemText primary={branch.pharmacy_name} />
                </Branch>
              ))}
            </List>}
          </DialogContent>
          <ButtonContainer justify={`center`} padding={`20px`}>
            <DialogButton onClick={this.handleClose.bind(this)}>Cancel</DialogButton>
          </ButtonContainer>
        </StyledDialog>
      </Fragment>
    )
  }
}

export default LegacyBranchesDialog

const StyledDialog = styled(({ color, ...other }) => (
  <Dialog {...other} classes={{ paper: 'paper' }} />
))`
&& .paper {
  padding:22px 22px 20px 22px;
  width: 483px;
  height: 544px;
  border-radius: 22.5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  box-sizing: border-box;
}
&& .paper div[class^="MuiDialogActions"] {
  justify-content:center;
}
&& .paper div[class^="MuiDialogActions-action"] div:first-child button  {
  margin-right:25px;
}
&& ::-webkit-scrollbar
{
  width: 2px;
  height: 8px;
  background-color: #e5e5e5;
  border-radius: 50px;
}
&& ::-webkit-scrollbar-thumb {
  background: #3c3c3c;
  height: 76px;
  border-radius: 50px;
}
&& .MuiSvgIcon-root-34 {
  width: 2em;
}
`
const DialogButton = styled(Button)`
&&
{
  width: 117px;
  height: 40px;
  border-radius: 20px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.28);
  color: white;
  background-color: #939393;
}
`
const SearchBar = styled(InputBase)`
&&
{
  width: 441px;
  min-height: 43px;
  border-radius: 21.5px;
  border: solid 1px #212121;
  margin-bottom: 20px;
}
`
const Branch = styled(ListItem)`
&&
{
  border-bottom: solid 1px #e4e3e3;
}
`
